module.exports = __webpack_public_path__ + "media/good_morning.da012968.mp3";